import React from "react";
import PropTypes from "prop-types";
import Popup from "reactjs-popup";

const contentStyle = {
  border: "none",
  borderRadius: "8px",
  padding: 0,
  width: "min(460px, calc(100vw - 40px))",
  background: "var(--sl-bg-primary)",
};

const PropagateChangesModal = ({ open, eventCount, saving, onChoose, onCancel }) => {
  const noun = eventCount === 1 ? "event" : "events";
  return (
    <Popup open={open} modal closeOnDocumentClick={!saving} onClose={onCancel} contentStyle={contentStyle} className="popup-modal">
      <div className="series-propagate-modal">
        <h3 className="series-propagate-title">Apply changes to events?</h3>
        <p className="series-propagate-body">
          Save these changes to the series only, or also update the {eventCount} {noun} in this series
          (name, description, type, age restriction, photo, and template)?
        </p>
        <div className="series-propagate-actions">
          <button type="button" className="btn btn-outline-secondary" onClick={onCancel} disabled={saving}>
            Cancel
          </button>
          <button type="button" className="btn btn-outline-primary" onClick={() => onChoose(false)} disabled={saving}>
            Series only
          </button>
          <button type="button" className="btn btn-primary" onClick={() => onChoose(true)} disabled={saving}>
            {saving ? "Saving…" : "Update all events"}
          </button>
        </div>
      </div>
    </Popup>
  );
};

PropagateChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  eventCount: PropTypes.number,
  saving: PropTypes.bool,
  onChoose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default PropagateChangesModal;
